import React from "react";

import GenericIntegrationCard from "../GenericIntegrationCard";
import ChromeIcon from "../../../../common/icons/ChromeIcon";
import { INTEGRATION_KEYS } from "../../../../integrations/IntegrationsHelper";
import steps from "../../../../integrations/onboarding/steps";

export default function ChromeIntegrationCard({ controller }) {
  return (
    <GenericIntegrationCard
      controller={controller}
      integrationType={INTEGRATION_KEYS.chrome}
      integrationStep={steps.chrome}
      IconTag={ChromeIcon}
      title="Track your screen-time at light speed!"
      description="Connect your Chrome to automatically track activities on your computer."
    />
  );
}
